// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5374":"1be4a97c","5850":"1be4a97c","6775":"a7291ea8","7066":"1f78cd32"}[chunkId] + ".chunk.css";
};